import _extends from "@babel/runtime/helpers/extends";
import { Box } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials/react';
import { RuleElementGroupedList, useAutoScrolling, useElementToggle } from '@wix/rules-panel-ui';
import { useAtomValue } from 'jotai';
import React, { useMemo, useState } from 'react';
import { scrollerNodeRefAtom } from '../../../atoms/session-atoms';
import { AltImageRule } from './alt-image-rule';
import { useAltTextScreenContext } from './drill-in/alt-text-screen/alt-text-screen-wrapper';
import { useEntityGroups } from './utils/use-entity-groups';
export const AltImageRuleFixer = _ref => {
  let {
    pageId,
    altImagesRules,
    enableDecorativeImages,
    openImageElement,
    appDefinitionId,
    showSummary = true,
    disabled = false
  } = _ref;
  const {
    t
  } = useTranslation();
  const getGroups = useEntityGroups();
  const {
    openNextElement,
    toggleElement,
    selectedElementId,
    previousOpenElementId
  } = useElementToggle();
  const [showLoader, setShowLoader] = useState(false);
  const scrollerNodeRef = useAtomValue(scrollerNodeRefAtom);
  const {
    selectedItemContentRef,
    selectedItemHeaderRef
  } = useAutoScrolling(selectedElementId, scrollerNodeRef);
  const {
    actions: {
      setIsLoading
    }
  } = useAltTextScreenContext();
  const groups = useMemo(() => getGroups(altImagesRules), [getGroups, altImagesRules]);
  const propGroups = (groups == null ? void 0 : groups.map(altTextGroup => {
    return {
      ...altTextGroup,
      elements: altTextGroup.elements.map((ruleProps, index) => {
        return {
          ...ruleProps,
          contentComponent: /*#__PURE__*/React.createElement(AltImageRule, _extends({
            key: ruleProps.id
          }, ruleProps, {
            appDefinitionId: appDefinitionId,
            contentRef: selectedItemContentRef,
            disabled: disabled,
            elementIndex: index,
            enableDecorativeImages: enableDecorativeImages,
            headerRef: selectedItemHeaderRef,
            isOpen: !disabled && selectedElementId === ruleProps.id,
            pageId: pageId,
            previousOpenElementId: previousOpenElementId,
            showLoader: showLoader,
            toggleElement: toggleElement(ruleProps.id, () => openImageElement(ruleProps))
          }))
        };
      })
    };
  })) ?? [];
  return /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(RuleElementGroupedList, {
    groups: propGroups,
    headerTitle: t('accessibility-wizard.rules-list.alt-image.list.failed-elements-number.heading'),
    openImageElement: openImageElement,
    openNextElement: openNextElement,
    setIsLoading: setIsLoading,
    setShowLoader: setShowLoader,
    showSummary: showSummary
  }));
};
//# sourceMappingURL=alt-image-rule-fixer.js.map